<div class="flex flex-col gap-0.5 leading-tight">
  <!-- Teléfono -->
  @if (phone()) {
    <div class="group flex items-center gap-1">
      <mat-icon class="!h-4 !w-4 !text-sm text-gray-400">phone</mat-icon>
      <span class="text-sm text-gray-700">{{ phone() }}</span>
      <mat-icon
        (click)="copyToClipboard(phone()!, 'phone')"
        [matTooltip]="'routing.SUB_ROUTE_PARTNERS.CELLS.CONTACT_COPY_TOOLTIP' | t"
        class="!h-4 !w-4 !text-sm text-gray-400 opacity-0 transition-opacity hover:text-gray-400 group-hover:opacity-100"
        >content_copy</mat-icon
      >
    </div>
  }

  <!-- Email -->
  @if (email()) {
    <div class="group flex items-center gap-1">
      <mat-icon class="!h-4 !w-4 !text-sm text-gray-400">email</mat-icon>
      <span class="max-w-[180px] truncate text-sm text-gray-700" [matTooltip]="email()!">
        {{ email() }}
      </span>
      <mat-icon
        (click)="copyToClipboard(email()!, 'email')"
        [matTooltip]="'routing.SUB_ROUTE_PARTNERS.CELLS.CONTACT_COPY_TOOLTIP' | t"
        class="!h-4 !w-4 !text-sm text-gray-400 opacity-0 transition-opacity hover:text-gray-400 group-hover:opacity-100"
        >content_copy</mat-icon
      >
    </div>
  }

  <!-- Contacto -->
  @if (contactName()) {
    <div class="flex items-center gap-1">
      <mat-icon class="!h-4 !w-4 !text-sm text-gray-400">person</mat-icon>
      <span class="max-w-[180px] truncate text-sm text-gray-600" [matTooltip]="contactName()!">
        {{ contactName() }}
      </span>
    </div>
  }

  <!-- Sin información -->
  @if (!phone() && !email() && !contactName()) {
    <span class="text-sm text-gray-400">-</span>
  }
</div>
